module.exports = __webpack_public_path__ + "img/Avanzar.ca91784d.svg";